var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{ref:"popover",attrs:{"placement":"right","width":"200","trigger":"manual","title":_vm.title,"content":_vm.status,"value":_vm.visible}})
}
var staticRenderFns = []

export { render, staticRenderFns }